import { RouteObject } from "react-router-dom";
import { SignupPage } from "./ui/SignupPage";

export const signupRoute: RouteObject = {
  path: "/signup",
  element: <SignupPage />,
};
